import { defineRule } from '../rule.js';

/** Maximum continuous load as a share of the breaker rating. */
export const CIRCUIT_LOAD_LIMIT = 0.8;

/** W: the known load on a power source exceeds 80 % of its `maxAmps`. */
export const circuitOverload = defineRule(
  'circuit-overload',
  'warning',
  { en: 'Circuit overloaded', de: 'Stromkreis überlastet' },
  (data, emit) =>
    Object.values(data.power).flatMap((source) => {
      if (source.maxAmps === undefined) return [];
      const loads = Object.values(data.items).filter((i) => i.power?.sourceId === source.id);
      const watts = loads.reduce((sum, i) => sum + (i.power?.watts ?? 0), 0);
      const amps = watts / source.voltage;
      if (amps <= CIRCUIT_LOAD_LIMIT * source.maxAmps) return [];
      return [
        emit([source.id, ...loads.map((i) => i.id)], {
          amps: Math.round(amps * 10) / 10,
          maxAmps: source.maxAmps,
        }),
      ];
    }),
);
